// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nc-table {\n  -webkit-box-flex:1;\n      -ms-flex:1;\n          flex:1;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
